import './types';
import {Reporter, ReportOpts} from '../Reporter';

export class DynatraceReporter implements Reporter {
    public report({error}: ReportOpts) {
        if (error) {
            try {
                dtrum?.reportError(error);
            } catch (e) {}
        }
    }
}
